export default () => {
  const { $t } = useNuxtApp()
  const typeReportData = [
    {
      key: 'status',
      label: $t('labels.status'),
      disabled: false
    },
    {
      key: 'statistical',
      label: $t('labels.viewStatic'),
      disabled: false
    },
    {
      key: 'work',
      label: $t('labels.work'),
      disabled: false
    }
  ]

  const classItemSelect = [
    {
      key: 'vehicles',
      label: $t('labels.vehicle'),
      disabled: false
    },
    {
      key: 'driver',
      label: $t('labels.driver'),
      disabled: false
    },
    {
      key: 'quoteRequest',
      label: $t('labels.quoteRequest'),
      disabled: false
    },
    {
      key: 'quote',
      label: $t('labels.quote'),
      disabled: false
    },
    {
      key: 'order',
      label: $t('labels.order'),
      disabled: false
    }
  ]

  const labelTypeReport = {
    status: $t('labels.status'),
    statistical: $t('labels.viewStatic'),
    work: $t('labels.work')
  }

  const labelModuleReport = {
    vehicles: $t('labels.vehicle'),
    driver: $t('labels.driver'),
    quote: $t('labels.quote'),
    order: $t('labels.order'),
    quoteRequest: $t('labels.quoteRequest')
  }
  return {
    typeReportData,
    classItemSelect,
    labelTypeReport,
    labelModuleReport
  }
}
